module.exports = __webpack_public_path__ + "static/media/Baroncello.60cd76b2.png";